import React, {useState, useEffect, useContext} from 'react'
import Layout from "components/sales/layout/layout";
import { Button } from "react-bootstrap";
import localization from "assets/localization/localization";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import {toast} from "react-toastify";
import { Fragment } from 'react';
import DivLayout from 'components/sales/divLayout/divLayout';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import { Link } from 'react-router-dom';
import Images from 'assets/images/imageData';

const ToolkitInspectionForm = ({
    documentUploadUrlPublic,
    fetchMaterials,
    fetchMaterialList,
    saveMaterialInspection
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [consent, setConsent] = useState(false);
    const [msg, setMsg] = useState(`I, ${JSON.parse(localStorage.getItem("loginDetails")).name} agree to the fact that the self tool kit inspection has been completed successfully. The tool has been inspected, maintained, and tested with utmost accuracy.`);
    const [submit, setSubmit] = useState(false);
    const input = {
        material_id:0,
        status:"",
        photo:[], 
        remarks:''
    }
    const [formData, setFormData] = useState([input]);
    const { baseUrl } = useContext(BaseUrl);

    useEffect(()=> {
        (async()=> {
            setIsLoading(true)
            await fetchMaterials()
            setIsLoading(false)
        })();
    }, [])

    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                onClick={()=>{
                    const form = [...formData]
                    form.push(input)
                    setFormData(form)
                }}
                className="filter-hamburger btn btn-transparent"
                >
                Add Material
                </Button>
                <Button
                onClick={()=>{
                    for(let form of formData){
                        if(form.material_id==0 || form.status==""){
                            toast.error('Select all fields from dropdown');
                            return;
                        }
                    }
                    setIsModal(true)
                }}
                className="filter-hamburger btn btn-transparent"
                >
                Proceed
                </Button>
            </Fragment>
            
          );
    }
    const handleModalHide = () => {
        setIsModal(false);
      }
    const handleDelete = (index) => {
        const form = [...formData]
        form.splice(index,1)
        setFormData(form)
    }

    return(
        <Layout
            title="Inspection Reports"
            Buttons={headerBtns}
            isGoback
            isLoading={isLoading}
        >
            <div className="container-fluid">
                <div className="card">
                        <div className="card-header" style={{display:"flex",justifyContent:"space-between"}}>
                            <>Inspect Toolkit</>
                        </div>
                        {formData.map((element, index) => {
                        return (
                        <div className="card-body">
                        <div className='row'>
                        <div className='col-md-4'>
                        <DropDownInput
                            data={fetchMaterialList}
                            label="Toolkit Type"
                            required
                            errorMsg={localization.requiredName}
                            getIdValue={(val) => { 
                                const updatedFormData = [...formData];
                                updatedFormData[index] = { ...updatedFormData[index], material_id: val.id };
                                setFormData(updatedFormData);
                            }}
                            isStarRequired={true}
                        />
                        </div>
                        <div className='col-md-4'>
                        <DropDownInput
                            data={[
                                { id: "Available", name: "Available" },
                                { id: "Not Available", name: "Not Available" },
                                { id: "Damaged", name: "Damaged" },
                                { id: "Misplaced", name: "Misplaced" },
                                { id: "Not Required", name: "Not Required" },
                              ]}
                            label="Status"
                            required
                            errorMsg={localization.requiredName}
                            getIdValue={(val) => { 
                                const updatedFormData = [...formData];
                                updatedFormData[index] = { ...updatedFormData[index], status: val.id };
                                setFormData(updatedFormData);
                            }}
                            isStarRequired={true}
                        />
                        </div>
                        <div className='col-md-4'>
                        <TextAreaInput
                            type="text"
                            rows={2}
                            className={`inline-css scrollbar-styling`}
                            label="Add Remarks"
                            value={formData[index]?.remarks}
                            inputValue={formData[index]?.remarks}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>{ const updatedFormData = [...formData];
                                updatedFormData[index] = { ...updatedFormData[index], remarks: e.target.value };
                                setFormData(updatedFormData);}}
                        />
                        </div></div>
                        <div className="form-group form-btn">
                            <FileUpload
                            id={index}
                            multiple
                            accept=".png,.jpg,.jpeg"
                            documentUploadUrl={documentUploadUrlPublic}
                            onChange={(val) =>{ 
                                const updatedFormData = [...formData];
                                updatedFormData[index] = { ...updatedFormData[index], photo: val };
                                setFormData(updatedFormData);
                            }}
                            >
                            <span className="btn btn-transparent">
                                Upload Image
                            </span>
                            </FileUpload>
                        </div>
                            {index!=0 && <Button onClick={()=>handleDelete(index)} src="https://static.vecteezy.com/system/resources/previews/009/267/401/original/minus-sign-icon-free-png.png">Remove</Button>}
                            {index!=formData.length-1 && <hr></hr>}</div>
                        )
                    })}
                </div>
            </div>
            <ModalPop
                title=""
                show={isModal}
                handleModalHide={handleModalHide}
            >
            {submit==true?
            <div className="text-center">
                <div className="success">
                    <img src={Images?.tick} alt="" />
                </div>
                <h5>Site Inspection form created successfully</h5>
                <Link to={`${baseUrl}/toolkit-inspection`} className="btn btn-primary mb-4">View Toolkit Inspection Reports</Link>
            </div>
            :<>
                <Checkbox
                    label={msg}
                    type="checkbox"
                    errorMsg={localization.isRequired}
                    onChange={val => setConsent(val)}
                    width={"10%"}
                />
                <Button
                    onClick={()=>{
                        if(consent){
                            (async () => {
                                console.log(formData)
                                const res =  await saveMaterialInspection(formData);
                                if(res === true) {
                                    toast.success("Inspection submitted successfully");
                                    setSubmit(true)
                                }
                             })();
                        }
                        else{
                            toast.error('Give your consent.');
                            return;
                        }
                    }}
                    className="filter-hamburger btn btn-transparent text-center"
                >
                {localization.submit}
                </Button></>}
            </ModalPop>
        </Layout>
    )

}

export default ToolkitInspectionForm